<template>
  <VBusHelper
    :reactOn="$constants.EVENTS.SERVICES.INITIATION.CONFIRM"
    :handler="() => $refs.modal.show()"
  />

  <VBusHelper
    :reactOn="$constants.EVENTS.SERVICES.INITIATION.INITIATION_FAILED"
    :handler="() => $refs.modal.show()"
  />

  <VBusHelper
    :reactOn="$constants.EVENTS.SERVICES.INITIATION.INITIATED"
    :handler="() => $refs.modal.show()"
  />

  <VBusHelper
    :reactOn="$constants.EVENTS.SERVICES.CLOSE_SERVICE_INITIATION"
    :handler="() => $refs.modal.hide()"
  />

  <DialogComponent
    ref="modal"
    type="fullscreen"
    @closed="
      ({ source }) => {
        source !== 'continueAction' &&
          $stores.services.state?.paymentInitiated &&
          $bus.emit($constants.EVENTS.SERVICES.CLOSE_OPERATION_INITIATION);
      }
    "
  >
    <div
      class="h-full w-full flex items-center justify-center text-center p-6 pb-[20vh]"
    >
      <div
        v-if="$stores.services.state?.initiatingPayment"
        class="flex flex-col items-center space-y-4"
      >
        <ImgComponent
          src="https://cdn-icons-png.flaticon.com/512/189/189792.png"
          class="max-w-xl w-[60vw] animate-spin opacity-70 p-[20%]"
        />
        <h2 class="text-2xl font-semibold">Traitement en cours</h2>
        <p class="text-gray-600">Veuillez patienter…</p>
      </div>

      <!-- ERROR -->
      <div
        v-else-if="$stores.services.state?.initiationError"
        class="flex flex-col items-center space-y-4"
      >
        <div class="max-w-xl w-[60vw] saturate-50">
          <LottieComponent
            class="scale-150"
            :src="$constants.SERVICES.LOTTIES.PAYMENT_ERROR"
          />
        </div>
        <h2 class="text-2xl font-semibold text-primary">
          {{ $stores.services.state?.initiationErrorTitle }}
        </h2>
        <p class="text-gray-600">
          {{ $stores.services.state?.initiationError }}
        </p>
        <div class="flex gap-5">
          <button
            class="buttonComponent text-2xl border-primary border bg-transparent! text-primary!"
            @click="() => $refs.modal.hide()"
          >
            Terminer
          </button>
        </div>
      </div>

      <!-- SUCCESS WAVE — En attente du lien de paiement (polling actif) -->
      <div
        v-else-if="
          $stores.services.state?.paymentInitiated &&
          $stores.services.state?.wavePaymentLinkPolling
        "
        class="flex flex-col items-center space-y-6"
      >
        <ImgComponent
          src="https://cdn-icons-png.flaticon.com/512/189/189792.png"
          class="max-w-xl w-[40vw] animate-spin opacity-70 p-[10%]"
        />
        <h2 class="text-2xl font-semibold text-primary">
          Génération du lien Wave…
        </h2>
        <p class="text-gray-500 text-center text-sm max-w-xs">
          Nous préparons votre lien de paiement Wave sécurisé.<br />Cela prend
          quelques secondes, veuillez patienter…
        </p>
      </div>

      <!-- SUCCESS WAVE — Lien prêt, CTA bouton -->
      <div
        v-else-if="
          $stores.services.state?.paymentInitiated &&
          $stores.services.state?.wavePaymentLink
        "
        class="flex flex-col items-center space-y-6"
      >
        <div class="max-w-xl w-[60vw]">
          <LottieComponent
            class="scale-150"
            :src="$constants.SERVICES.LOTTIES.PAYMENT_SUCCESS"
          />
        </div>
        <h2 class="text-2xl font-semibold text-green-600">
          Lien de paiement prêt !
        </h2>
        <p class="text-gray-600 text-center text-sm max-w-xs">
          Cliquez sur le bouton ci-dessous pour confirmer votre paiement Wave.
        </p>
        <a
          :href="$stores.services.state?.wavePaymentLink"
          target="_blank"
          rel="noopener noreferrer"
          class="buttonComponent text-xl flex items-center justify-center gap-3 w-full max-w-xs"
        >
          <svg class="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
            <path
              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z"
            />
          </svg>
          Confirmer le paiement Wave
        </a>
        <button
          class="text-gray-400 underline text-sm mt-2"
          @click="() => $refs.modal.hide()"
        >
          Fermer
        </button>
      </div>

      <!-- SUCCESS WAVE — Timeout (pas de lien dans le délai imparti) -->
      <div
        v-else-if="
          $stores.services.state?.paymentInitiated &&
          $stores.services.state?.wavePaymentLinkTimeout
        "
        class="flex flex-col items-center space-y-4"
      >
        <div class="max-w-xl w-[60vw] saturate-50">
          <LottieComponent
            class="scale-150"
            :src="$constants.SERVICES.LOTTIES.PAYMENT_ERROR"
          />
        </div>
        <h2 class="text-2xl font-semibold text-primary">Délai dépassé</h2>
        <p class="text-gray-600 text-center text-sm max-w-xs">
          Le lien de paiement Wave n'a pas pu être généré dans le délai imparti.
          Contactez le support si le problème persiste.
        </p>
        <button
          class="buttonComponent text-2xl"
          @click="() => $refs.modal.hide()"
        >
          Fermer
        </button>
      </div>

      <!-- SUCCESS standard (non-Wave) -->
      <div
        v-else-if="$stores.services.state?.paymentInitiated"
        class="flex flex-col items-center space-y-4"
      >
        <div class="max-w-xl w-[60vw]">
          <LottieComponent
            class="scale-150"
            :src="$constants.SERVICES.LOTTIES.PAYMENT_SUCCESS"
          />
        </div>
        <h2 class="text-2xl font-semibold text-green-600">
          <span>Paiement initié</span>
        </h2>
        <p class="text-gray-600">
          <span
            v-if="
              $stores.services.state?.transactionInitiation?.operation?.id ==
                'fund' &&
              $stores.services.state?.transactionInitiation?.phoneOperator ==
                'MOOV' &&
              $stores.user.state?.current?.countryCode == 'TG'
            "
          >
            Si le push USSD tarde à venir, tapez
            <span class="font-bold text-red-500">*155*2*4#</span> pour valider
            la transaction
          </span>

          <span v-else> La transaction a été démarrée avec succès. </span>
        </p>
        <div>
          <button
            class="buttonComponent text-2xl"
            @click="() => $refs.modal.hide()"
          >
            Terminer
          </button>
        </div>
      </div>

      <!-- DEFAULT -->
      <div v-else class="flex flex-col items-center space-y-4">
        <ImgComponent
          src="https://cdn-icons-png.flaticon.com/512/1828/1828901.png"
          class="w-20 h-20"
        />
        <h2 class="text-xl font-semibold">Aucune donnée</h2>
        <p class="text-gray-500">En attente d'une nouvelle opération…</p>
        <div>
          <button
            class="buttonComponent text-2xl"
            @click="() => $refs.modal.hide()"
          >
            Terminer
          </button>
        </div>
      </div>
    </div>
  </DialogComponent>
</template>
